module.exports = __webpack_public_path__ + "5418fac180c02149807e777340de344d.png";